import React from 'react'

import style from './style.css'

export default props => (
    <label className={style.checkboxScope}>
        <input
            type='checkbox'
            defaultChecked={props.checked}
            onChange={props.handleChange || null}
            name={props.name || null}
            style={props.style || {}}
            className={style.checkbox}
        />
        <div className={style.checkmark} />
        <div className={style.content}>
            {props.children || props.label}
        </div>
    </label>
)


// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/atoms/Forms/checkbox.js